import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { BeneficiaryDescription } from '../../components/FormDescriptions/BeneficiaryDescriptions';
import content from '../../locales/en/content.json';

const SCHEMA_ENUM = ['applicant', 'sponsor', 'other'];

const TITLE_TEXT = content['app-status--role-title--update'];
const INPUT_LABEL = content['app-status--role-label'];

const SCHEMA_LABELS = {
  applicant: content['app-status--role-option--update-applicant'],
  sponsor: content['app-status--role-option--update-sponsor'],
  other: content['app-status--role-option--update-other'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    certifierRole: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
  },
  schema: {
    type: 'object',
    required: ['certifierRole'],
    properties: {
      certifierRole: radioSchema(SCHEMA_ENUM),
    },
  },
  ContentBeforeButtons: BeneficiaryDescription,
};
